import { Burger, ANIMATION_END } from '../core'

$.fn.Header = function(parent) {
  let self = this

  if (self.data('header')) {
    return self.data('header')
  }

  self.animation_done = true
  self.has_scrolled_up = false
  self.burger = undefined

  self.initialize_burger = function() {
    self.burger = new Burger(self.find('.header__burger').get(0), {
      onToggle: function(burger) {
        if (burger.isExpanded) {
          $('body').addClass('--menu-open')
        } else {
          $('body').removeClass('--menu-open')
        }
      },
    })
  }

  self.animation_start = function() {
    self.animation_done = false
    self.on(ANIMATION_END, self.animation_end)
  }

  self.animation_end = function() {
    self.off(ANIMATION_END, self.animation_end)
    self.animation_done = true
    self.scrolled($.mlmi.scroller.scrollTop())
  }

  self.scrolled = function(top, direction) {
    if (!self.animation_done) { return }
    let scrolled_past = (top >= self.outerHeight(false) * 2),
    top_limit = !$.mlmi.mobile.isMobile && $.mlmi.is_front_page ? $(window).height() - $('.header').outerHeight(false) : 1
    if (top <= top_limit) {
      $('body').removeClass('--menu-fixed --menu-open --menu-dismissed')
      self.burger.maybe_close()
      self.has_scrolled_up = false
    } else if (direction == 'down' && $('body').hasClass('--menu-fixed') && !$('body').hasClass('--menu-dismissed')) {
      $('body').removeClass('--menu-fixed --menu-open').addClass('--menu-dismissed')
      self.animation_start()
      self.burger.maybe_close()
    } else if (direction == 'up' && (!self.has_scrolled_up || $('body').hasClass('--menu-dismissed')) && !$('body').hasClass('--menu-fixed')) {
      self.has_scrolled_up = true
      $('body').removeClass('--menu-dismissed --menu-open').addClass('--menu-fixed')
      self.animation_start()
      self.burger.maybe_close()
    }
  }

  return function() {
    self.initialize_burger()
    $.mlmi.scroller.add(self.scrolled)
    $(window).on('load resize orientationchange', self.scrolled)
    self.scrolled()
    return self
  }()
}
